<template>
    <v-img
        class="rounded-circle preview"
        contain
        :src="getMaterialPreview()"
    />
</template>

<script>
    export default {
        name: 'MaterialPreview',
        props: {
            materialId: {
                type: String,
                required: true,
            },
        },
        methods: {
            getMaterialPreview() {
                let materialItems = this.$props.materialId.split(/-(.*)/, 2);
                let isPrefab = materialItems.length > 1;
                if (isPrefab)
                    return process.env.PREFAB_PREVIEW + materialItems[0] + '/' + materialItems[1];
                else
                    return process.env.MATERIAL_PREVIEW + materialItems[0];
            }
        }
    }
</script>

<style lang="scss" scoped>
    .v-image.preview {
        width: 24px;
        height: 24px;
        max-width: 24px;
        border: 1px solid rgba(39, 34, 34, 0.11);
    }
</style>


// WEBPACK FOOTER //
// src/components/configurableTour/components/MaterialPreview.vue